export type ProjectStatus = 'live' | 'upcoming' | 'ended' | 'success' | 'failed'
export type ProjectType = 'launchpad' | 'presale'
export type ProjectCategory = 'DeFi' | 'Infrastructure' | 'DAO' | 'Markets' | 'Research'

export const projectCategories: ProjectCategory[] = ['DeFi', 'Infrastructure', 'DAO', 'Markets', 'Research']

export interface Project {
  id: string
  type: ProjectType
  name: string
  ticker: string
  tagline: string
  description: string
  imageUrl?: string
  category: ProjectCategory
  status: ProjectStatus
  raised: number
  goal: number
  softCap?: number
  hardCap?: number
  participants: number
  currentPrice?: number
  marketCap?: number
  supply?: number
  maxSupply?: number
  basePrice?: number
  priceIncrement?: number
  minContribution?: number
  maxContribution?: number
  /** Share of remaining ETH (after 3% platform fee) that seeds LP. 70–100. */
  lpPct?: number
  /** Tokens minted per 1 ETH contributed. */
  tokensPerEth?: number
  /** Listing tokens per 1 ETH used when seeding post-presale liquidity. */
  listingRate?: number
  /** Creator ETH percent of remaining proceeds after the 3% platform fee (0–30). */
  teamPct?: number
  quote?: 'usd' | 'eth'
  source?: 'mock' | 'sim'
  creatorAddress?: string
  contractAddress?: string
  tokenAddress?: string
  shareSlug?: string
  startsAt?: string
  endsAt: string
  website?: string
  twitter?: string
  youtube?: string
  telegram?: string
  discord?: string
  tiktok?: string
  facebook?: string
  instagram?: string
}

function daysFromNow(days: number): string {
  return new Date(Date.now() + days * 24 * 60 * 60 * 1000).toISOString()
}

export const projects: Project[] = []

export function getProjectsByType(type: ProjectType): Project[] {
  return projects.filter(p => p.type === type)
}

export function getProjectById(id: string): Project | undefined {
  const key = id.trim().toLowerCase()
  return projects.find((p) => {
    return p.id === id
      || p.id.toLowerCase() === key
      || p.shareSlug?.toLowerCase() === key
  })
}
